import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSaAdd = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 200,
	height: 200,
	fill: "none",
	viewBox: "0 0 200 200",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-add_svg__paint0_linear_4001_7561)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M181.2 72.64h-45.37a13.8 13.8 0 0 0-12.25 20.17l-10.9 12.63 16.56-6.86a14 14 0 0 0 6.59 1.67h45.36a13.8 13.8 0 1 0 0-27.61"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-add_svg__paint1_linear_4001_7561)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M131.67 80.4H168"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-add_svg__paint2_linear_4001_7561)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M131.67 86.19h50.72"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-add_svg__paint3_linear_4001_7561)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M131.67 91.48h50.72"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-add_svg__paint4_linear_4001_7561)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M181.82 110.66h-59.8v27.29h59.8z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-add_svg__paint5_linear_4001_7561)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M131.67 118.69h40.88"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-add_svg__paint6_linear_4001_7561)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M131.67 125.32h21.96"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-soft-light, #CBD9F3)",
			d: "M86.01 78.37H74.1c0 1.83-.6 3.61-1.71 5.07a18 18 0 0 1 6.46 5.52l23.34 20.8v-3.67a48.4 48.4 0 0 0-10.37-30 8.5 8.5 0 0 1-5.81 2.28"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-soft-light, #CBD9F3)",
			d: "M94.2 124.87 84.16 112.2a97 97 0 0 1-.6 8.36 23.67 23.67 0 0 1-37.02 16.87 23 23 0 0 1-6.96-7.62l-.42.94a8.33 8.33 0 1 1-14.53-8.13L44.06 94c3.47-6.02 8.02-10.63 14.04-12.2a8 8 0 0 1-.73-3.43H45.45a8.53 8.53 0 0 1-8.49-7.71h-.04c-2.8 0-5.08-3.15-5.08-7.02q0-.53.05-1.04a48.6 48.6 0 0 0 21.7 92.08h48.6v-27.43a8.3 8.3 0 0 1-7.99-2.38"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-add_svg__paint7_linear_4001_7561)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M102.18 109.76v-3.67a48.4 48.4 0 0 0-10.36-30"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-add_svg__paint8_linear_4001_7561)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M31.9 62.6a48.6 48.6 0 0 0 21.7 92.08h48.59v-27.43"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-accent, #93CB71)",
			d: "m111.11 129.7-4.1-5.68a8.4 8.4 0 0 1-4.98 3.27l4.26 5.9a2.98 2.98 0 0 0 4.82-3.48"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-add_svg__paint9_linear_4001_7561)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m111.11 129.7-4.1-5.68a8.4 8.4 0 0 1-4.98 3.27l4.26 5.9a2.98 2.98 0 0 0 4.82-3.48"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-accent, #93CB71)",
			d: "M102.91 127.04a8.4 8.4 0 0 1-6.47-.49q.03.5.22.97l3.08 7.33a2.97 2.97 0 1 0 5.48-2.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-add_svg__paint10_linear_4001_7561)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M102.91 127.04a8.4 8.4 0 0 1-6.47-.49q.03.5.22.97l3.08 7.33a2.97 2.97 0 1 0 5.48-2.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-accent, #93CB71)",
			d: "m115.95 123.77-6.27-4.91a3 3 0 0 0-1.15-.55 8.3 8.3 0 0 1-1.66 5.9l5.41 4.24a2.97 2.97 0 0 0 3.66-4.68"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-add_svg__paint11_linear_4001_7561)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m115.95 123.77-6.27-4.91a3 3 0 0 0-1.15-.55 8.3 8.3 0 0 1-1.66 5.9l5.41 4.24a2.97 2.97 0 0 0 3.66-4.68"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-accent, #93CB71)",
			d: "M115.42 111.59a2.97 2.97 0 0 0-3.94-1.48l-5.9 2.68.73.65a8.3 8.3 0 0 1 2.19 4.55l5.44-2.47a3 3 0 0 0 1.48-3.93"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-add_svg__paint12_linear_4001_7561)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M115.42 111.59a2.97 2.97 0 0 0-3.94-1.48l-5.9 2.68.73.65a8.3 8.3 0 0 1 2.19 4.55l5.44-2.47a3 3 0 0 0 1.48-3.93"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-add_svg__paint13_linear_4001_7561)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m84.16 112.21 10.04 12.66a8.33 8.33 0 0 0 12.1-11.43L78.86 88.96"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-add_svg__paint14_linear_4001_7561)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M39.58 129.82a23.64 23.64 0 0 0 43.99-9.25c1.68-15.02.52-31.24-11.19-37.13"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-add_svg__paint15_linear_4001_7561)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M58.1 81.8c-6.02 1.57-10.57 6.18-14.04 12.2"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-accent, #93CB71)",
			d: "m30.27 134.87-.79 6.3a2.97 2.97 0 0 0 5.9.75l1.03-8.23a8.4 8.4 0 0 1-6.14 1.18"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-add_svg__paint16_linear_4001_7561)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m30.27 134.87-.79 6.3a2.97 2.97 0 0 0 5.9.75l1.03-8.23a8.4 8.4 0 0 1-6.14 1.18"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-accent, #93CB71)",
			d: "M27.83 133.96a8 8 0 0 1-2.54-2.19l-3.55 5.44a2.97 2.97 0 0 0 4.98 3.25l3.64-5.58a8 8 0 0 1-2.53-.92"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-add_svg__paint17_linear_4001_7561)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M27.83 133.96a8 8 0 0 1-2.54-2.19l-3.55 5.44a2.97 2.97 0 0 0 4.98 3.25l3.64-5.58a8 8 0 0 1-2.53-.92"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-accent, #93CB71)",
			d: "m23.87 124.46-6.42 6.22a2.97 2.97 0 1 0 4.13 4.27l3.53-3.42a8.3 8.3 0 0 1-1.24-7.07"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-add_svg__paint18_linear_4001_7561)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m23.87 124.46-6.42 6.22a2.97 2.97 0 1 0 4.13 4.27l3.53-3.42a8.3 8.3 0 0 1-1.24-7.07"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-accent, #93CB71)",
			d: "m40.27 128.3-1.11 2.46a8 8 0 0 1-2.27 2.6l3.28 3.4a2.97 2.97 0 0 0 4.28-4.11z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-add_svg__paint19_linear_4001_7561)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m40.27 128.3-1.11 2.46a8 8 0 0 1-2.27 2.6l3.28 3.4a2.97 2.97 0 0 0 4.28-4.11z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-add_svg__paint20_linear_4001_7561)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M55.28 95.07a4.98 4.98 0 0 0-8.66-4.84l-22 32.4a8.32 8.32 0 0 0 14.53 8.13z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-add_svg__paint21_linear_4001_7561)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M57.37 78.37a8.37 8.37 0 0 0 16.73 0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-add_svg__paint22_linear_4001_7561)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M36.96 70.65a8.53 8.53 0 0 0 8.5 7.71H86a8.53 8.53 0 0 0 8.53-8.52v-6.17a28.81 28.81 0 0 0-56.77-6.96"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-soft, #A4BCEB)",
			d: "m36.73 37.31-1.5 19.7a3.8 3.8 0 0 1 3.38 0l-1.5-19.7a2.46 2.46 0 1 0-.38 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-add_svg__paint23_linear_4001_7561)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m36.73 37.31-1.5 19.7a3.8 3.8 0 0 1 3.38 0l-1.5-19.7a2.46 2.46 0 1 0-.38 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-add_svg__paint24_linear_4001_7561)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M36.92 56.62c-2.8 0-5.08 3.14-5.08 7.02s2.27 7.02 5.08 7.02c2.8 0 5.08-3.15 5.08-7.02 0-3.88-2.27-7.02-5.08-7.02"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-add_svg__paint25_linear_4001_7561)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M84.57 53.94h.02a5.5 5.5 0 0 1 5.5 5.5v8.38a5.5 5.5 0 0 1-5.52 5.5h-32.8a5.5 5.5 0 0 1-5.5-5.5v-8.37a5.5 5.5 0 0 1 5.5-5.51z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-add_svg__paint26_linear_4001_7561)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M56.04 61.68za1.96 1.96 0 1 1 0 3.91h-.01a1.96 1.96 0 0 1-.19-3.9z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-add_svg__paint27_linear_4001_7561)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M81.9 61.68a1.96 1.96 0 1 1 0 3.91 1.96 1.96 0 0 1 0-3.91"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-soft, #A4BCEB)",
			d: "M84.57 54.44h-32.8a5 5 0 0 0-5 5v8.38a5 5 0 0 0 5 5.01h32.8a5 5 0 0 0 5.01-5v-8.38a5 5 0 0 0-5-5M56.05 66.09a2.46 2.46 0 1 1-.01-4.91 2.46 2.46 0 0 1 0 4.91m13.58 1.88a3.13 3.13 0 0 1-3.13-3.13h6.26a3.13 3.13 0 0 1-3.13 3.13m12.27-1.88a2.46 2.46 0 1 1 0-4.91 2.46 2.46 0 0 1 0 4.91"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-add_svg__paint28_linear_4001_7561)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M66.5 64.83a3.13 3.13 0 0 0 6.26 0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-add_svg__paint29_linear_4001_7561)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M140.43 169.45h9.18"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-add_svg__paint30_linear_4001_7561)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M145.02 174.04v-9.18"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-add_svg__paint31_linear_4001_7561)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m169.3 33.38 6.5 6.48"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-add_svg__paint32_linear_4001_7561)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m169.3 39.86 6.5-6.48"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-add_svg__paint33_linear_4001_7561)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m16.54 156.18 3.31 3.3"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-add_svg__paint34_linear_4001_7561)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m16.54 159.49 3.31-3.31"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-add_svg__paint35_linear_4001_7561)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m81.07 28.28 2.84 4.67 3.33-6.99"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-add_svg__paint36_linear_4001_7561)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M168 148.06h5"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-add_svg__paint37_linear_4001_7561)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M170.5 150.56v-5"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-add_svg__paint38_linear_4001_7561)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M155.83 38.95h-28.36a5.45 5.45 0 0 0-5.45 5.45v11.33c0 1.24.42 2.45 1.21 3.42l-10.54 21.97 18.98-19.94h24.16a5.45 5.45 0 0 0 5.45-5.45V44.4a5.45 5.45 0 0 0-5.45-5.45"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-blue, #88ABE7)",
			d: "M140.72 56.5s-3.72-.47-3.72-2.28c0-1.59 2.1-2.15 3.72-2.36zm0-14c.03 0 7.2.98 7.2 4.68s-5.6 4.47-7.2 4.68z"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-add_svg__paint0_linear_4001_7561",
				x1: 153.844,
				x2: 153.531,
				y1: 100.562,
				y2: 78.571,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-add_svg__paint1_linear_4001_7561",
				x1: 149.836,
				x2: 149.835,
				y1: 81.252,
				y2: 80.582,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-add_svg__paint2_linear_4001_7561",
				x1: 157.031,
				x2: 157.03,
				y1: 87.037,
				y2: 86.367,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-add_svg__paint3_linear_4001_7561",
				x1: 157.031,
				x2: 157.03,
				y1: 92.336,
				y2: 91.666,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-add_svg__paint4_linear_4001_7561",
				x1: 151.919,
				x2: 151.62,
				y1: 133.891,
				y2: 115.599,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-add_svg__paint5_linear_4001_7561",
				x1: 152.112,
				x2: 152.112,
				y1: 119.536,
				y2: 118.865,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-add_svg__paint6_linear_4001_7561",
				x1: 142.649,
				x2: 142.648,
				y1: 126.169,
				y2: 125.498,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-add_svg__paint7_linear_4001_7561",
				x1: 96.999,
				x2: 94.408,
				y1: 104.752,
				y2: 82.477,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-add_svg__paint8_linear_4001_7561",
				x1: 53.595,
				x2: 51.502,
				y1: 140.986,
				y2: 79.317,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-add_svg__paint9_linear_4001_7561",
				x1: 106.854,
				x2: 106.585,
				y1: 132.87,
				y2: 125.911,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-add_svg__paint10_linear_4001_7561",
				x1: 100.957,
				x2: 100.682,
				y1: 135.213,
				y2: 128.402,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-add_svg__paint11_linear_4001_7561",
				x1: 111.964,
				x2: 111.692,
				y1: 127.462,
				y2: 120.262,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-add_svg__paint12_linear_4001_7561",
				x1: 110.631,
				x2: 110.474,
				y1: 116.78,
				y2: 111.322,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-add_svg__paint13_linear_4001_7561",
				x1: 93.713,
				x2: 92.517,
				y1: 121.748,
				y2: 95.978,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-add_svg__paint14_linear_4001_7561",
				x1: 61.884,
				x2: 60.063,
				y1: 132.997,
				y2: 94.05,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-add_svg__paint15_linear_4001_7561",
				x1: 51.081,
				x2: 50.827,
				y1: 92.186,
				y2: 84.014,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-add_svg__paint16_linear_4001_7561",
				x1: 32.94,
				x2: 32.542,
				y1: 142.846,
				y2: 135.659,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-add_svg__paint17_linear_4001_7561",
				x1: 25.817,
				x2: 25.553,
				y1: 140.291,
				y2: 133.592,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-add_svg__paint18_linear_4001_7561",
				x1: 20.795,
				x2: 20.435,
				y1: 134.154,
				y2: 126.535,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-add_svg__paint19_linear_4001_7561",
				x1: 41.08,
				x2: 40.828,
				y1: 136.268,
				y2: 129.998,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-add_svg__paint20_linear_4001_7561",
				x1: 39.667,
				x2: 38.028,
				y1: 127.954,
				y2: 96.614,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-add_svg__paint21_linear_4001_7561",
				x1: 65.731,
				x2: 65.63,
				y1: 85.487,
				y2: 79.88,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-add_svg__paint22_linear_4001_7561",
				x1: 65.75,
				x2: 64.961,
				y1: 71.895,
				y2: 42.748,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-add_svg__paint23_linear_4001_7561",
				x1: 36.921,
				x2: 34.053,
				y1: 53.355,
				y2: 37.371,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-add_svg__paint24_linear_4001_7561",
				x1: 36.919,
				x2: 36.455,
				y1: 68.568,
				y2: 59.176,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-add_svg__paint25_linear_4001_7561",
				x1: 68.172,
				x2: 67.982,
				y1: 70.094,
				y2: 57.767,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-add_svg__paint26_linear_4001_7561",
				x1: 56.018,
				x2: 55.902,
				y1: 65.363,
				y2: 62.072,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-add_svg__paint27_linear_4001_7561",
				x1: 81.899,
				x2: 81.781,
				y1: 65.363,
				y2: 62.072,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-add_svg__paint28_linear_4001_7561",
				x1: 69.632,
				x2: 69.594,
				y1: 67.501,
				y2: 65.402,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-add_svg__paint29_linear_4001_7561",
				x1: 145.018,
				x2: 145.016,
				y1: 170.298,
				y2: 169.628,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-add_svg__paint30_linear_4001_7561",
				x1: 145.518,
				x2: 143.693,
				y1: 172.67,
				y2: 167.117,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-add_svg__paint31_linear_4001_7561",
				x1: 172.553,
				x2: 172.397,
				y1: 38.899,
				y2: 34.554,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-add_svg__paint32_linear_4001_7561",
				x1: 172.553,
				x2: 172.397,
				y1: 38.899,
				y2: 34.554,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-add_svg__paint33_linear_4001_7561",
				x1: 18.198,
				x2: 18.118,
				y1: 158.993,
				y2: 156.777,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-add_svg__paint34_linear_4001_7561",
				x1: 18.198,
				x2: 18.118,
				y1: 158.993,
				y2: 156.777,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-add_svg__paint35_linear_4001_7561",
				x1: 84.157,
				x2: 83.968,
				y1: 31.915,
				y2: 27.236,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-add_svg__paint36_linear_4001_7561",
				x1: 170.503,
				x2: 170.498,
				y1: 148.91,
				y2: 148.239,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-add_svg__paint37_linear_4001_7561",
				x1: 171.002,
				x2: 170.419,
				y1: 149.817,
				y2: 146.566,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-add_svg__paint38_linear_4001_7561",
				x1: 136.987,
				x2: 136.109,
				y1: 74.846,
				y2: 46.601,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			})
		] })
	]
});
export default SvgSaAdd;
